import React from 'react'
import { Button, Container, Typography, TooltipV2 } from '@cleartrip/ct-design-components'
import { formatCurrency } from '@/utils'
import { FLIGHT_DETAILS_DONE_BTN, TUPPLE_BOOK_BTN } from '@/constants/Srp'


const FlightDetailsFooter = ({
    footerData = {},
    showPerAdultPricing = false,
    onContinueClick = () => {},
    perAdultTooltip = <></>,
    isTripDetails = false,
    isRoundTrip = false,
    isIntl = false
}) => {
    const { strikeOffPrice = 0, displayPrice = 0, couponCallout = '' } = footerData as { strikeOffPrice: number, displayPrice: number, couponCallout: string } || {}
    const hasStrikeOff = strikeOffPrice > displayPrice
    return (
        <Container
            className="py-4 px-6 flex flex-between"
            style={{
                boxShadow: '0px -4px 16px 0px rgba(26, 26, 26, 0.08)'
            }}
        >
            <Container>
                <Container className="flex flex-baseline">
                    <Typography variant="HM1">{formatCurrency(displayPrice)}</Typography>
                    {hasStrikeOff && (
                        <Typography variant="B3" color="subheading" isStriked={true} className="pl-1">
                            {formatCurrency(strikeOffPrice)}
                        </Typography>
                    )}
                </Container>
                {showPerAdultPricing && (
                    <TooltipV2
                        position="top"
                        labelContainer={
                            <Typography variant="B3" color="subheading" className="c-pointer">
                                /adult
                            </Typography>
                        }
                        styleConfig={{
                            tooltipContainer: {
                                css: {
                                    left: '0px',
                                    top: '-116px'
                                }
                            },
                            tooltipArrowContainer: {
                                css: {
                                    top: '-3px'
                                }
                            }
                        }}
                    >
                        {perAdultTooltip}
                    </TooltipV2>    
                )}
                <Typography variant="B3" color="success" className="mt-1">
                    {couponCallout}
                </Typography>
            </Container>
            <Button size="large" variant="contained" color="secondary" minWidth="160px" onClick={onContinueClick}>
                {/* CTA should be DONE for international roundtrip individual trip */}
                {isIntl ? isTripDetails ? TUPPLE_BOOK_BTN : isRoundTrip ? FLIGHT_DETAILS_DONE_BTN : TUPPLE_BOOK_BTN : TUPPLE_BOOK_BTN}
            </Button>
        </Container>
    )
}

export default FlightDetailsFooter
